import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";

import { DffMatSliderWrapperModule, DffSideModule, SpinnerModule } from "@dffedb/ui";

import { ForbrugsnotifikationRoutingModule } from "./forbrugsnotifikation-routing.module";
import { ForbrugsnotifikationSektionComponent } from "./forbrugsnotifikation-sektion/forbrugsnotifikation-sektion.component";
import { ForbrugsnotifikationUdsendelseComponent } from "./forbrugsnotifikation-udsendelse/forbrugsnotifikation-udsendelse.component";
import { ForbrugsnotifikationComponent } from "./forbrugsnotifikation.component";

@NgModule({
    imports: [
        CommonModule,
        DffSideModule,
        DffMatSliderWrapperModule,
        FormsModule,
        ForbrugsnotifikationRoutingModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDividerModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatSliderModule,
        ReactiveFormsModule,
        SpinnerModule
    ],
    exports: [],
    declarations: [ForbrugsnotifikationComponent, ForbrugsnotifikationUdsendelseComponent, ForbrugsnotifikationSektionComponent],
    providers: []
})
export class EForsyningFeaturesForbrugsnotifikationModule {}
